// Theme manager — applies a CSS data attribute to <html> so tailwind/CSS can react.
// Themes: "cream" (default), "light" (pure white), "dark" (midnight), "neon" (futuristic cyan portal).

const THEMES = ["cream", "light", "dark", "neon"];
const KEY = "ts_theme";

export function applyTheme(theme) {
  if (typeof document === "undefined") return;
  const t = THEMES.includes(theme) ? theme : "neon";
  document.documentElement.setAttribute("data-theme", t);
  try { localStorage.setItem(KEY, t); } catch {}
}

export function getStoredTheme() {
  if (typeof window === "undefined") return "neon";
  try {
    const t = localStorage.getItem(KEY);
    return THEMES.includes(t) ? t : "neon";
  } catch { return "neon"; }
}

export function listThemes() { return [...THEMES]; }

// Futuristic "portal" switch: expanding neon ring + smooth color morph, then applies the theme.
export function playPortalTransition(next, done) {
  if (typeof document === "undefined") { done && done(); return; }
  const html = document.documentElement;
  const fx = document.createElement("div");
  fx.className = "ts-portal-fx";
  fx.innerHTML = '<div class="ts-portal-ring"></div><div class="ts-portal-core"></div>';
  document.body.appendChild(fx);
  html.classList.add("ts-theme-anim");
  setTimeout(() => { applyTheme(next); done && done(); }, 240);
  setTimeout(() => { fx.remove(); html.classList.remove("ts-theme-anim"); }, 1000);
}
